var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVerkehrsrechtRotlichtverstossDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 624,
    height: 433,
    viewBox: "0 0 624 433",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_170_2764)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.399 306.398C178.799 306.398 174.199 310.998 174.199 316.598V340.498C174.199 346.098 178.799 350.698 184.399 350.698H197.299C202.899 350.698 207.499 346.098 207.499 340.498V316.598C207.499 310.998 202.899 306.398 197.299 306.398H184.399Z",
    fill: "#868A91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.798 351.502H410.898C404.798 351.502 399.898 346.602 399.898 340.502V316.602C399.898 310.502 404.798 305.602 410.898 305.602H423.798C429.898 305.602 434.798 310.502 434.798 316.602V340.502C434.798 346.602 429.798 351.502 423.798 351.502Z",
    fill: "#868A91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.201 332.4H192.201C182.101 332.4 173.801 326.4 173.801 319.1V276.2L184.901 264.5H424.701L433.601 276.2V319C433.601 326.4 425.301 332.4 415.201 332.4Z",
    fill: "#137F7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.599 285.999H186.099L183.699 248.999L185.199 245.199L194.099 223.199H413.999L426.099 248.099L423.599 285.999Z",
    fill: "#137F7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.602 248.202L423.902 276.002H371.602V255.402L424.202 245.102L425.602 248.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.302 255.401V276.001H185.902L184.102 249.001L185.602 245.301L237.302 255.401Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.6 229.498H195.5L218.7 152.298C220.6 145.798 226.6 141.198 233.5 141.198L377.3 139.798C384.5 139.698 390.7 144.498 392.5 151.498L412.6 229.498Z",
    fill: "#137F7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.902 222.202L212.102 220.002C211.302 220.002 210.602 219.302 210.602 218.502C210.602 218.402 210.602 218.202 210.702 218.102L228.302 163.102C228.502 162.502 229.102 162.102 229.702 162.102H377.502C378.102 162.102 378.702 162.502 378.902 163.102L397.202 220.202C397.502 221.002 397.002 221.802 396.202 222.102C396.202 222.202 396.102 222.202 395.902 222.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.8 149.3H279.3C278.9 149.3 278.5 148.9 278.3 148.2C278.1 147.5 278.1 146.8 278.4 146.1L282.5 135.8C282.7 135.3 283 135 283.4 135H324.8C325.2 135 325.5 135.3 325.7 135.8L329.8 146.1C330 146.8 330.1 147.5 329.9 148.2C329.6 148.9 329.3 149.3 328.8 149.3Z",
    fill: "#137F7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.6 228.002H163V220.802C163 216.002 166.9 212.102 171.7 212.102H195.5V228.002H195.6Z",
    fill: "#137F7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.1 228.002H412.5V212.102H436.3C441.1 212.102 445 216.002 445 220.802V228.002H445.1Z",
    fill: "#137F7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.285 339.551L0.0507812 396.758L0.726981 398.64L159.961 341.433L159.285 339.551Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.852 339.579L447.176 341.461L606.41 398.651L607.086 396.768L447.852 339.579Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.898 381.102H303.398V368.802H312.898V381.102ZM312.898 356.402H303.398V344.102H312.898V356.402Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.898 432.102H303.398V419.802H312.898V432.102ZM312.898 407.402H303.398V395.102H312.898V407.402Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0802 83.5469L52.1055 102.732V197.057L68.0928 206.65L100.068 187.465V93.1394L84.0802 83.5469Z",
    fill: "#4D5359"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0938 182.668V388.905C68.0938 390.504 69.6927 392.102 71.2914 393.701C74.4889 395.3 80.8836 395.3 84.0811 393.701C85.6799 392.102 85.68 392.103 85.68 390.504V182.668H68.0938Z",
    fill: "#868A91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0938 112.325L100.068 93.1406V187.466L68.0938 206.651V112.325Z",
    fill: "#868A91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0928 206.648L52.1055 197.056V102.73L68.0928 112.323V206.648Z",
    fill: "#454B52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7031 102.732L85.6779 83.5469L101.665 93.1394L69.6905 112.324L53.7031 102.732Z",
    fill: "#868A91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.63 130.102C95.1413 123.561 95.8523 116.226 92.2181 113.72C88.5838 111.213 81.9805 114.485 77.4692 121.026C72.9579 127.568 72.2469 134.903 75.8812 137.409C79.5154 139.915 86.1187 136.644 90.63 130.102Z",
    fill: "#DC3545"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M90.6104 155.669C95.1217 149.127 95.8328 141.792 92.1985 139.286C88.5643 136.78 81.9609 140.051 77.4496 146.593C72.9383 153.135 72.2274 160.469 75.8617 162.976C79.4959 165.482 86.0991 162.211 90.6104 155.669Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.52,
    d: "M90.5948 181.235C95.1061 174.694 95.8172 167.359 92.1829 164.852C88.5487 162.346 81.9453 165.618 77.434 172.159C72.9227 178.701 72.2118 186.036 75.846 188.542C79.4803 191.048 86.0835 187.777 90.5948 181.235Z",
    fill: "#73BA25"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_170_2764"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 623.6,
    height: 432.1,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerkehrsrechtRotlichtverstossDark);
export default __webpack_public_path__ + "static/media/Verkehrsrecht_Rotlichtverstoss_dark.d76d78549c96db6c4ecba39669019049.svg";
export { ForwardRef as ReactComponent };